import React from "react";
/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { Dialog } from "primereact/dialog";
import MarketplacePartnerScreen from "../../MarketplacePartnerScreen";

const DomainSelectionOverlay = ({
    onHide,
    isVisible,
    marketplaceNetworks,
    handleDomainSelection,
    orderIndex,
    networkMappings,
    domainToCustomerMappings,
    currentCustomer,
    marketplaceOrders,
}) => {

    function getParticipatingDomains() {
        let participatingDomains = [];
        try {
            let orderFormat = marketplaceOrders[orderIndex]?.format

            if (!orderFormat) {
                return participatingDomains
            }

            for (let [id, v] of Object.entries(networkMappings || {})) {
                /* skip domains belonging to the currently-selected customer */
                if (domainToCustomerMappings[id] === currentCustomer) {
                    continue;
                }

                let isMarketplaceInformationSet = v.marketplaceEnabled && v.domainOverview && Object.keys(v.domainOverview).length

                if (isMarketplaceInformationSet) {
                    if (orderFormat === 'video') {
                        if (v.domainOverview.allows_video) {
                            participatingDomains.push({ ...v.domainOverview, id })
                        }
                    } else if (orderFormat === 'display') {
                        participatingDomains.push({ ...v.domainOverview, id })
                    }
                }

            }
        } catch (err) {
            console.log(err)
        }

        return participatingDomains;
    }

    function getSelectedDomainsSet() {
        return new Set(marketplaceOrders?.[orderIndex]?.networks || [])
    }

    return (
        <Dialog
            visible={isVisible}
            style={{ width: "80%" }}
            onHide={onHide}
            css={css`
                .p-dialog-content {
                    min-height: 350px;
                }
            `}
        >
            <MarketplacePartnerScreen
                allowDownloadCsvLink={true}
                allowLayoutSelection={true}
                availableNetworks={marketplaceNetworks}
                participatingDomains={getParticipatingDomains(networkMappings)}
                hasStaticData={true}
                initialLayout="row"
                selectedDomainsSet={getSelectedDomainsSet()}
                enableDomainSelection={true}
                marketplaceOrder={marketplaceOrders?.[orderIndex || 0]}
                domainSelectionHandler={({ domainId }) => {
                    let selectedSet = getSelectedDomainsSet();
                    handleDomainSelection({ orderIndex, isAdditionOperation: !selectedSet.has(domainId), domainId })
                }}
            />
        </Dialog>
    );
};

export default DomainSelectionOverlay;
